// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"943ca2eb","150":"403df280","590":"a294f9d9","656":"100bb5b9","676":"f094a6f5","687":"7abb13dc","821":"d747a9c2","852":"dc5b9f84","959":"602a4d58"}[chunkId] + ".chunk.js";
};